import React from 'react';
import styled from 'styled-components';
import Calendar from 'rev.sdk.js/Components/Calendar';
import {DT} from 'rev.sdk.js/Components/Calendar/CalendarUtil';

function DateCell(props) {
  const {year, month, date, classNames: _classNames, onClick} = props;
  const curr = DT({year, month, date});

  let availSessions = [];
  let classNames = [];

  // for (const product of products) {
  //   const [y, m, d] = product.session.date.split('-');
  //   if (
  //     curr.getFullYear() === parseInt(y) &&
  //     curr.getMonth() + 1 === parseInt(m) &&
  //     curr.getDate() === parseInt(d)
  //   ) {
  //     availSessions.push(product);
  //   }
  // }

  return (
    <DateCellWrapper
      className={_classNames.concat(classNames).join(' ')}
      onClick={(e) => {
        onClick(e);
      }}>
      <div style={{fontSize: '1rem'}}>{date}</div>
    </DateCellWrapper>
  );
}

const DateCellWrapper = styled.div`
  position: relative;
  /* here to custom*/
  &.disabled::after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  &.r-today::after {
    content: '';
  }

  &.r-cell.r-date.r-today,
  .r-cell.r-date.r-selected {
    font-weight: 600;
    background-color: var(--primaryColor);
    border-color: white;
    color: white;
  }

  &.r-cell.r-date.r-selected {
    background-color: var(--primaryColor);
  }

  &.r-cell.r-date:not(.disabled, .past):hover {
    background-color: var(--primaryColor);
    border-color: white;
  }
`;

function CalendarLanding(props) {
  const {size, selectedDt, setSelectedDt} = props;

  return (
    <Wrapper size={size}>
      <div className="calendar">
        <Calendar
          onSelect={({year, month, date, dt}) => {
            setSelectedDt(
              selectedDt
                ? selectedDt.getTime() === dt.getTime()
                  ? null
                  : dt
                : dt,
            );
          }}
          renderDate={(props) => {
            return <DateCell key={props.date} {...props} />;
          }}
        />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  /* width: ${(props) => props.size}px; */
  border-radius: 6px;
  overflow: hidden;

  & > .calendar {
    & .r-inner {
      padding-bottom: 10px;
      background-color: white;
    }
    & .r-inner > .r-row.r-head {
      & > .r-cell.r-title {
        font-weight: 500;
      }

      & > .r-cell.r-next,
      .r-cell.r-prev {
        display: none;
      }

      & > .r-cell.r-next:hover,
      .r-cell.r-prev:hover {
        background-color: var(--primaryColor);
      }
    }

    & .r-inner > .r-weekdays {
      & .r-cell:first-child,
      .r-cell:last-child {
        color: red;
      }
    }
  }

  & > .calendar > div:after {
    padding-bottom: 73%; // control whole calendar height!!
  }
`;

export default CalendarLanding;
